'use strict';

import config from '../../../js/config';
import utilities from '../../../js/utilities';

var $ = require('jquery'),
  Backbone = require('backbone'),
  personalData = null;

var CurrencyDropdownView = Backbone.View.extend({

  events: {
    'click .HeaderDd-list-item': 'currencyDropdownClick'
  },

  initialize: function(options) {
    personalData = options.model.personalizedData;
    this.useCachedData();
  },

  currencyDropdownClick: function(e) {
    e.preventDefault();

    var $link = $(e.currentTarget),
      $form = this.$el.find('form'),
      $currencyCode = this.$el.find('input[name=currencyCode]');

    $currencyCode.val($link.data('code'));
    $form.submit();
  },

  setCurrencyDropdownValue: function() {
    if (!personalData.hasCompleteCurrencyData) {
      utilities.sessionStorageSave(config.sessionVariables.header.personalInfo, JSON.stringify(personalData));
    }
    this.getSelectedCurrency();
    this.$el.siblings().find('span.Header-navBar-item--dropdown-symbol').html(personalData.currency.symbol);
    this.$el.siblings().find('span.Header-navBar-item--dropdown-name').html(personalData.currency.isoCode);
  },

  getSelectedCurrency: function() {
    if (personalData && personalData.currencyString) {
      personalData.currency.isoCode = personalData.currencyString.split('&')[0].split('=')[1];
      let downcasedIsoCode = personalData.currency.isoCode.toLowerCase();
      this.$el.find('.HeaderDd-currency-form a').each((i, e) => {
        let $elem = $(e);
        if ($elem.hasClass('is-active')) {
          $elem.removeClass('is-active');
        }
        if ($elem.data('code').toLowerCase() === downcasedIsoCode) {
          personalData.currency.symbol = $elem.data('symbol');
          personalData.hasCompleteCurrencyData = true;
          $elem.addClass('is-active');
        }
      });
    }
  },

  useCachedData: function() {
    this.setCurrencyDropdownValue();
  }

});

module.exports = CurrencyDropdownView;



// WEBPACK FOOTER //
// ./assets/components/Header/js/CurrencyDropdownView.js